import React from 'react';

export default function Footer() {
  return (
    <footer className='bg-gradient-to-b from-[#242423] to-[#000000] text-white py-8'>
      <div className='container mx-auto flex flex-col md:flex-row justify-between items-center'>
        {/* Company Logo */}
        <div className='mb-6 md:mb-0'>
          <img
            src='/images/pivara_logo.png'
            alt='Company Logo'
            className='h-32'
          />
        </div>

        {/* Contact Information */}
        <div className='text-center md:text-left mb-6 md:mb-0'>
          <p className='text-lg font-semibold slavic-font'>Контакт:</p>
          <p className='font-sans'>
            <a
              href='mailto:info@djeneral.com'
              className='hover:text-yellow-500'
            >
              info@djeneralpivara.com
            </a>
          </p>
          <p className='font-sans'>+381 63 506406</p>
          <p className='font-sans font-normal'>9 Мај 29, 22320 Инђија</p>
        </div>

        {/* Social Media Links */}
        <div className='flex space-x-6'>
          <a
            href='https://www.instagram.com/djeneral.pivoo'
            target='_blank'
            rel='noopener noreferrer'
            className='hover:text-yellow-500'
          >
            <img
              src='/images/instagram.png'
              alt='Instagram'
              className='h-8 w-8'
            />
          </a>
          <a
            href='https://www.tiktok.com/@djeneral.pivo'
            target='_blank'
            rel='noopener noreferrer'
            className='hover:text-yellow-500'
          >
            <img src='/images/tiktok.png' alt='TikTok' className='h-8 w-8' />
          </a>
        </div>
      </div>

      {/* Copyright */}
      <div className='text-center mt-6'>
        <p className='text-sm'>2025 Ђенерал Пивара. Сва права задржана.</p>
      </div>
    </footer>
  );
}
